
  var _styles = {
  "magicmember-header-container": {
    "paddingTop": "0.21333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  }
};



  module.exports = _styles;
  